import { render, staticRenderFns } from "./RecipesView.vue?vue&type=template&id=3fe89060&"
import script from "./RecipesView.vue?vue&type=script&lang=js&"
export * from "./RecipesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports